module.exports = __webpack_public_path__ + "83c209007a02d48374f6d81c20ad4481.svg";